// Ошибка страницы: 404/403/500 показываются страницей ошибки вместо содержимого.
import { shallowRef } from 'vue';
import { router } from './router';

export class PageError extends Error {
  readonly statusCode: number;
  readonly statusMessage: string;
  readonly fatal: boolean;
  constructor(statusCode: number, message: string, fatal = false) {
    super(message);
    this.name = 'PageError';
    this.statusCode = statusCode;
    this.statusMessage = message;
    this.fatal = fatal;
  }
}

export const pageError = shallowRef<{ statusCode: number; message: string } | null>(null);
let deferred: { statusCode: number; message: string } | null = null;

/** Ошибка, обнаруженная охраной маршрута: показывается после перехода, а не сбрасывается им. */
export function deferError(error: { statusCode: number; message: string }): void { deferred = error; }
export function takeDeferredError() { const value = deferred; deferred = null; return value; }

export function createError(input: { statusCode?: number; statusMessage?: string; message?: string; fatal?: boolean } | string): PageError {
  if (typeof input === 'string') return new PageError(500, input);
  return new PageError(input.statusCode ?? 500, input.message ?? input.statusMessage ?? '', input.fatal);
}

export function showError(error: unknown): void {
  const value = error as { statusCode?: number; message?: string };
  pageError.value = { statusCode: Number(value?.statusCode ?? 500), message: value?.message ?? '' };
}

export async function clearError(options: { redirect?: string } = {}): Promise<void> {
  pageError.value = null;
  if (options.redirect) await router.push(options.redirect);
  else window.location.reload();
}
